/**
 * Point position indicator
 * - used in Olsztyn
 * - showing state of PME - should correspond with it
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Konva from 'konva'
import Element from './element.es6'

export default class Ppi extends Element {
  setDefaultShapes () {
    const redCross = new Konva.Group({
      name: 'redCross',
      x: 0,
      y: 0,
      visible: false
    })

    const firstLine = new Ren.Line({
      points: [5, 5, 25, 25],
      stroke: 'red',
      strokeEnabled: true,
      strokeWidth: 2
    })

    const secondLine = new Ren.Line({
      points: [25, 5, 5, 25],
      stroke: 'red',
      strokeEnabled: true,
      strokeWidth: 2
    })

    redCross.add(firstLine)
    redCross.add(secondLine)

    const whiteCross = new Konva.Group({
      name: 'blocked',
      x: 0,
      y: 0,
      visible: false
    })

    const whiteFirstLine = new Ren.Line({
      points: [5, 5, 25, 25],
      stroke: 'white',
      strokeEnabled: true,
      strokeWidth: 2
    })

    const whiteSecondLine = new Ren.Line({
      points: [25, 5, 5, 25],
      stroke: 'white',
      strokeEnabled: true,
      strokeWidth: 2
    })

    whiteCross.add(whiteFirstLine)
    whiteCross.add(whiteSecondLine)

    this.shapes.push(
      // basic shape three rooms
      new Ren.Rect({
        name: 'ppi',
        x: 0,
        y: 0,
        width: 30,
        height: 90,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 30, 30, 30],
        strokeWidth: 2,
        opacity: 0.8
      }),
      new Ren.Line({
        points: [0, 60, 30, 60],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 15,
        radius: 15,
        fill: Color.offlineGray
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 45,
        radius: 15,
        fill: Color.offlineGray
      }),

      new Ren.Circle({
        name: 'circle',
        x: 15,
        y: 75,
        radius: 15,
        fill: Color.offlineGray
      }),

      // signalling foor
      new Ren.Line({
        points: [15, 90, 15, 110],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 110, 30, 110],
        strokeWidth: 2,
        opacity: 0.8
      }),

      new Ren.Line({
        name: 'right',
        points: [5, 65, 25, 75, 5, 85],
        stroke: 'white',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: false
      }),

      new Ren.Line({
        name: 'left',
        points: [25, 65, 5, 75, 25, 85],
        stroke: 'white',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: false
      }),

      new Ren.Line({
        name: 'straight',
        points: [5, 55, 15, 35, 25, 55],
        stroke: 'white',
        strokeEnabled: true,
        strokeWidth: 2,
        visible: false
      }),

      redCross,
      whiteCross
    )
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)

    for (const [signalName, value] of Object.entries(status)) {
      console.log("signal name", signalName, value)
      this.modifyShape(signalName, 'visible', value === 1)
    }
  }
}
